module.exports = __webpack_public_path__ + "static/img/20.0ab6beb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/20.png
// module id = EfjV
// module chunks = 0